import { SxProps, Theme } from '@mui/material/styles';

export const textSx: SxProps<Theme> = (theme: Theme) => ({
  fontWeight: 600,
  fontSize: '18px',
});

export const rowGridSx: SxProps<Theme> = (theme: Theme) => ({
  display: 'grid',
  gap: '16px',
  width: '100%',
  '& > *': {
    maxWidth: 'none',
    boxSizing: 'border-box',
  },
  [theme.breakpoints.down('lg')]: {
    gridTemplateColumns: 'repeat(auto-fill, minmax(360px, 1fr))',
  },
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: 'repeat(auto-fill, minmax(368px, 1fr))',
  },
});

export const columnGridSx = {
  gap: '16px',
  display: 'flex',
  flexDirection: 'column',
};

export const boxSx = {
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
};
